import React, { useContext, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { isExpired, decodeToken } from "react-jwt";
import { TbUser } from "react-icons/tb"
import { FaFileMedicalAlt } from "react-icons/fa";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitialstates_jupiter';
import { TbWalk } from "react-icons/tb"
import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"

function Sidebar_Jupiter(props) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let activeClassName = "mm-active";
  const log_data = (data) => {
    //    console.log(data);
  }

  const [isVehicleinghtsaccess, setVehicleinghtsaccess] = useState(false)
  const [hasselfserviceaccess, sethasselfserviceaccess] = useState(false)
  const [hasselfserviceaccess_fleet_ev, sethasselfserviceaccess_fleet_ev] = useState(false)
  const [hasaisaccess, sethasaisaccess] = useState(false)
  const [hasworkbenchaccess, sethasworkbenchaccess] = useState(false)
  const [hasVehicleTXAccessERC, sethasVehicleTXAccessERC] = useState(false)
  const [hasVehicleTXAccessFLEETEV, sethasVehicleTXAccessFLEETEV] = useState(false)
  const [hasRealtimeSideBarAccess, sethasRealtimeSideBarAccess] = useState(false)
  const [hasMileageSaarathiAccess, setHasMileageSaarathiAccess] = useState(false)

  useEffect(() => {
    const token = JSON.parse(sessionStorage.user);
    let myDecodedToken = decodeToken(token.token);
    let access_type = myDecodedToken.access_type;
    // let access_type = "5,6,7,8"
    var split_str = access_type.split(",");
    if (split_str.indexOf("1") !== -1) {
      setVehicleinghtsaccess(true)
    }
    if (split_str.indexOf("3") !== -1) { //
      sethasRealtimeSideBarAccess(true)
    }
    // if (split_str.indexOf("6") !== -1) {
    //   sethasselfserviceaccess(true)
    // }
    // if (split_str.indexOf("7") !== -1) {
    //   sethasaisaccess(true)
    // }
    // if (split_str.indexOf("8") !== -1) {
    //   sethasworkbenchaccess(true)
    // }
    // if (split_str.indexOf("11") !== -1) {
    //   sethasselfserviceaccess_fleet_ev(true)
    // }
    // if (split_str.indexOf("13") !== -1) {
    //   sethasVehicleTXAccessERC(true)
    // }
    // if (split_str.indexOf("14") !== -1) {
    //   sethasVehicleTXAccessFLEETEV(true)
    // }
    // if (split_str.indexOf("3") !== -1) { //
    //   sethasRealtimeSideBarAccess(true)
    // }
    // if (split_str.indexOf("18") !== -1) {
    //   setHasMileageSaarathiAccess(true)
    // }
  }, [hasselfserviceaccess, isVehicleinghtsaccess, hasaisaccess, hasworkbenchaccess, hasselfserviceaccess_fleet_ev, hasRealtimeSideBarAccess, hasMileageSaarathiAccess])

  const selfserviceclicl = (e) => {

    e.preventDefault();
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "selfservice"

      }
    }, log_data)
    const API_URL = "http://172.31.154.201:2026/login/loginFleetEVApi?useremail="
    // const API_URL = "https://cvtmls3.infoportal.tatamotors.com/login/loginFleetEVApi?useremail="
    const token = JSON.parse(sessionStorage.user);
    // const token =JSON.parse(sessionStorage.user);
    //   setUserData(token);
    // const username = token.username;
    let myDecodedToken = decodeToken(token.token);
    const username = myDecodedToken.username;
    const table_name = myDecodedToken.table_name;
    const ev_bus = myDecodedToken.ev_bus;
    const hideShow = ev_bus.split("_");
    const loggedInType = hideShow[0];

    // console.log("token",token,username)
    // const url = API_URL_MAIN + username + "@tatamotors.com&table_name=ev_faultalert_occdur_dashboard&token=" + token + "&flag=fleet&user_type=ev"
    // const url = API_URL_MAIN + username + "@tatamotors.com&table_name=" + table_name + "&token=" + token + "&flag=fleet&user_type=ev"

    const url = API_URL + username + "@tatamotors.com&table_name=" + table_name + "&token=" + token + "&flag=fleet&user=" + loggedInType
    
    // dev :- ev
    // prod :- fleetEV_user
    function openInNewTab(url) {
      var win = window.open(url, "");
      win.focus();
    }
    openInNewTab(url);
  }

  const vehicleThreeSixtyClick = (e) => {

    e.preventDefault();
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "vehicle360"

      }
    }, log_data)

    const API_URL = "https://vehicle360cv.infoportal.tatamotors.com/login/loginVehicleFleetAscentsEV?username="
    // const API_URL = "http://172.31.154.201:8085/vehicle360/login/loginVehicleFleetAscentsEV?username="
    // const API_URL = "https://cvtmls3.infoportal.tatamotors.com/login/loginFleetEVApi?useremail="
    const token = JSON.parse(sessionStorage.user);
    // const token =JSON.parse(sessionStorage.user);
    //   setUserData(token);
    // const username = token.username;
    let myDecodedToken = decodeToken(token.token);
    const username = myDecodedToken.username;

    // console.log("token",token,username)
    // const url = API_URL_MAIN + username + "@tatamotors.com&table_name=ev_faultalert_occdur_dashboard&token=" + token + "&flag=fleet&user_type=ev"
    // const url = API_URL_MAIN + username + "@tatamotors.com&table_name=" + table_name + "&token=" + token + "&flag=fleet&user_type=ev"

    const url = API_URL + username + "&token=" + token
    
    // dev :- ev
    // prod :- fleetEV_user
    openInNewTabVTX(url);
  }

  function openInNewTabVTX(url) {
    var win = window.open(url, "");
    win.focus();
  }

  // const vehicleThreeSixtyClickProd = (e) => {

  //   e.preventDefault();
  //   fetchData({
  //     url: API_URL_MAIN + "auth/logging", body: {
  //       page_name: "vehicle360"

  //     }
  //   }, log_data)

  //   const API_URL = "https://vehicle360cv.infoportal.tatamotors.com/login/loginVehicleFleetAscentsEV?username="
  //   const token = JSON.parse(sessionStorage.user);
  //   let myDecodedToken = decodeToken(token.token);
  //   const username = myDecodedToken.username;

  //   const url = API_URL + username + "&token=" + token
  //   console.log("URL_V360_PROD", url);
  //   console.log("token_PROD", token);
  //   // dev :- ev
  //   // prod :- fleetEV_user
  //   openInNewTabVTX(url);
  // }

  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div className="app-sidebar sidebar-shadow">
        <div className="app-header__mobile-menu">
          <div>
            <button type="button" className="hamburger hamburger--elastic mobile-toggle-nav">
              <span className="hamburger-box">
                <span className="hamburger-inner" />
              </span>
            </button>
          </div>
        </div>
        <div className="app-header__menu">
          <span>
            <button type="button" className="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
              <span className="btn-icon-wrapper">
                <i className="fa fa-ellipsis-v fa-w-6" />
              </span>
            </button>
          </span>
        </div>
        <div className="scrollbar-sidebar">
          <div className="app-sidebar__inner">
            <ul className="vertical-nav-menu">
              <li>
                <NavLink to="/homepage" className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }}>
                  <span className="material-symbols-outlined metismenu-icon ev_h_icon">home</span>
                  <span className="link-title" style={{ fontWeight: 900 }}>Home</span>
                </NavLink>
              </li>
              {
                isVehicleinghtsaccess &&
                <li>
                  <NavLink to="/VehicleInsights_Jupiter" className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon">insights</span>
                    <span className="link-title">Vehicle Insights</span>
                  </NavLink>
                </li>
              }
              {
                hasRealtimeSideBarAccess &&
                <li>
                  <NavLink to="/realtime_Jupiter" className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon"><FaFileMedicalAlt /></span>
                    <span className="link-title">Real Time</span>
                  </NavLink>
                </li>
              }
              {
                loggedInUser.flagForHideShow === "ERC" &&
                hasselfserviceaccess &&
                <li>
                  <a className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }} href="#" onClick={selfserviceclicl}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon"><TbUser /></span>
                    <span className="link-title">Self Service</span>
                  </a>
                </li>
              }
              {
                loggedInUser.flagForHideShow === "FLEETEV" &&
                hasselfserviceaccess_fleet_ev &&
                <li>
                  <a className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }} href="#" onClick={selfserviceclicl}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon"><TbUser /></span>
                    <span className="link-title">Self Service</span>
                  </a>
                </li>
              }
              {
                (loggedInUser.flagForHideShow === "ERC" && hasVehicleTXAccessERC) &&
                (<>
                  <li>
                    <a className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }} href="#" onClick={vehicleThreeSixtyClick}>
                      <span className="material-symbols-outlined metismenu-icon ev_h_icon"><img src="../../../assets/img/vehicle_360_wt_ssss.png" width="25" height="22" /></span>
                      <span className="link-title">Vehicle 360</span>
                    </a>
                  </li>
                  {/* < li >
                    <a className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }} href="#" onClick={vehicleThreeSixtyClickProd}>
                      <span className="material-symbols-outlined metismenu-icon ev_h_icon"><img src="../../../assets/img/vehicle_360_wt_ssss.png" width="25" height="22" /></span>
                      <span className="link-title">Vehicle 360 P</span>
                    </a>
                  </li> */}
                </>)
              }
              {
                (loggedInUser.flagForHideShow === "FLEETEV" && hasVehicleTXAccessFLEETEV) &&
                (<>
                  <li>
                    <a className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }} href="#" onClick={vehicleThreeSixtyClick}>
                      <span className="material-symbols-outlined metismenu-icon ev_h_icon"><img src="../../../assets/img/vehicle_360_wt_ssss.png" width="25" height="22" /></span>
                      <span className="link-title">Vehicle 360</span>
                    </a>
                  </li>
                  {/* <li>
                    <a className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }} href="#" onClick={vehicleThreeSixtyClickProd}>
                      <span className="material-symbols-outlined metismenu-icon ev_h_icon"><img src="../../../assets/img/vehicle_360_wt_ssss.png" width="25" height="22" /></span>
                      <span className="link-title">Vehicle 360 P</span>
                    </a>
                  </li> */}
                </>)
              }
              {
                loggedInUser.flagForHideShow === "ERC" &&
                hasaisaccess &&
                <li>
                  <NavLink to="/arai" className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon"><TbWalk /></span>
                    <span className="link-title">ARAI</span>
                  </NavLink>
                </li>
              }
              {
                loggedInUser.flagForHideShow === "ERC" &&
                hasworkbenchaccess &&
                <li>
                  <NavLink to="/workbench" className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon"><TbWalk /></span>
                    <span className="link-title">Workbench</span>
                  </NavLink>
                </li>
              }
              {hasMileageSaarathiAccess &&
                <li>
                  <NavLink to="/MileageSaarathi_Ace" className={({ isActive }) => isActive ? activeClassName : undefined} style={{ display: "flex", alignItems: "center" }}>
                    <span className="material-symbols-outlined metismenu-icon ev_h_icon">speed</span>
                    <span className="link-title">Mileage Saarathi</span>
                  </NavLink>
                </li>
              }

            </ul>
          </div>
        </div>
      </div >
    </>
  );
}

export default Sidebar_Jupiter;
